class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    // Violet Eyes: slides back up on its own 3 seconds after opening (BNJMN, 19 Oct)
    this.clearAutoClose();
    this.notification.classList.remove('ve-pop-leaving');
    this.notification.classList.add('animate', 'active');
    this.autoCloseTimer = setTimeout(() => this.autoClose(), 3000);

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  // waits while the mouse is over the pop-up, then closes 0.8s after it leaves
  autoClose() {
    this.autoCloseTimer = null;
    if (!this.notification.classList.contains('active')) return;
    if (this.notification.matches(':hover')) {
      this.onAutoCloseLeave = () => {
        this.notification.removeEventListener('mouseleave', this.onAutoCloseLeave);
        this.onAutoCloseLeave = null;
        this.autoCloseTimer = setTimeout(() => this.autoClose(), 800);
      };
      this.notification.addEventListener('mouseleave', this.onAutoCloseLeave);
      return;
    }
    this.notification.classList.add('ve-pop-leaving');
    this.close();
    clearTimeout(this.leavingTimer);
    this.leavingTimer = setTimeout(() => this.notification.classList.remove('ve-pop-leaving'), 600);
  }

  clearAutoClose() {
    clearTimeout(this.autoCloseTimer);
    this.autoCloseTimer = null;
    if (this.onAutoCloseLeave) {
      this.notification.removeEventListener('mouseleave', this.onAutoCloseLeave);
      this.onAutoCloseLeave = null;
    }
  }

  close() {
    this.clearAutoClose();
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
